import styled from 'styled-components'

import { CopyButton, Truncate } from '@root/shared/ui-kit'

import type { Address } from '@root/entities/address/Address'
import type { ClassNameProps } from '@root/shared/react'

type ExploreTableAddressCellProps = {
  address: Address
} & ClassNameProps

export const ExploreTableAddressCell: React.FC<
  ExploreTableAddressCellProps
> = ({ className, address }) => {
  return (
    <Root className={className}>
      <Address_>
        <Truncate start={4} end={4}>
          {address}
        </Truncate>
      </Address_>
      <CopyButton value={address} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  gap: 3px;
  color: var(--text-11);
`

const Address_ = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`
